<div class="d-flex flex-column flex-shrink-0  text-formed  sidebar section-side-nav relative-sidebar" >


    <ul class="nav nav-pills flex-column mb-auto list-unstyled">
      <div class="nav-item top-item text-center">
        <img routerLink="/{{this.businessID}}/users/home" class="mb-2 pointer" src="../../assets/images/rekruu_logo.png" alt=""  height="70">

      </div>

      <li class="nav-item no-top-margin">
        <a routerLink="/{{this.businessID}}/users/home" id="dashboard" class="nav-link text-formed" aria-current="page">
            <img class="me-2 margin-icon-neg" [src]="selected_item == 'dashboard' ? '../../assets/icons/chart_icon_white.svg' : '../../assets/icons/chart_icon.svg'">Koti
        </a>
      </li>
      <li class="nav-item no-top-margin">
        <a routerLink="/{{this.businessID}}/search-alerts" id="search-alerts" class="nav-link text-formed" aria-current="page">
            <img class="me-2 margin-icon-neg" [src]="selected_item == 'search-alerts' ? '../../assets/icons/bell_icon_white.svg' : '../../assets/icons/bell_icon.svg'">Hakuvahdit
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/{{businessID}}/openings/standard" id="openings" class="nav-link text-formed" aria-current="page">
          <img class="me-2 margin-icon-neg" width="20" [src]="selected_item == 'openings' ? '../../assets/icons/sb_jobs_white.svg':'../../assets/icons/sb_jobs.svg'"/>Työpaikat <span *ngIf="numbers && numbers['applicants'] > 0" [ngClass]="numbers['applicants'] >= 10 ? 'numbertag-lg' : 'numbertag-sm'">{{numbers.applicants}}</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/{{businessID}}/messages" id="messages" class="nav-link text-formed">
          <img class="me-2 margin-icon-neg" width="20" [src]="selected_item == 'messages'? '../../assets/icons/sb_messages_white.svg':'../../assets/icons/letter_icon.svg'"/>Viestit <span *ngIf="numbers && numbers['messages'] > 0" [ngClass]="numbers['messages'] >= 10 ? 'numbertag-lg' : 'numbertag-sm'">{{numbers.messages}}</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/{{businessID}}/business-interests" id="interested" class="nav-link text-formed">
          <img class="me-2 margin-icon-neg" width="20" [src]="selected_item == 'interested' ? '../../assets/icons/sb_followers_white.svg' : '../../assets/icons/sb_followers.svg'"/>Seuraajat
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/{{businessID}}/lists" id="lists" class="nav-link text-formed">
          <span style="min-width: 25px;"><img class="margin-lists margin-icon-neg" width="14" [src]="selected_item == 'lists' ? '../../assets/icons/bookmark_icon_white.svg' :'../../assets/icons/bookmark_nav.svg'"/></span>
          Listat
        </a>
      </li>
      <li class="nav-item ">
        <a routerLink="/{{businessID}}/company-details" id="settings" class="nav-link text-formed relative-sidebar">
          <span style="min-width: 20px;">
            <img class="margin-lists margin-icon-neg" width="14" [src]="selected_item == 'settings' ? '../../assets/icons/sb_profile_white.svg' : '../../assets/icons/sb_profile.svg'"/>Oma profiili

          </span>
        </a>
      </li>
    </ul>



    <div class="bottom-container" *ngIf="businessData && businessData">
      <div class="logo ">
        <div class="relative-sidebar">
          <div class="flex-column text-center pointer" routerLink="/{{businessID}}/company-details">
            <div class="" *ngIf="businessData['logo']">
              <img src="{{businessData['logo']}}" alt="" class="contain text-center mb-2">            
            </div>
            <div class="" *ngIf="!businessData['logo']">
              <p class="semiboldtextblue80016">{{businessData['businessName']}}</p>
            </div>
            <p class="text-center normaltextblue90016 f-os">{{tokenData['firstName']}}</p>
          </div>
          <div class=" d-flex justify-content-center">
            <button class="btn btn-formed-main-blue-logout w-100" (click)="logout()"><img class="pe-2 margin-icon-neg" src="../../assets/icons/sign_out_white.svg" width="25" />Kirjaudu ulos</button>
  
          </div>
        </div>
      </div>
    </div>
  </div> 